import React from "react";
import '../assets/css/style.css';
import panel from '../assets/css/img/ITC_Limited.png';
import img from '../assets/css/img/Medplus.jpg';
import img1 from '../assets/css/img/compassgroup.jpg';
import img2 from '../assets/css/img/apr.png';
import img3 from '../assets/css/img/ramoji.png';
import img4 from '../assets/css/img/myhome.png';
import shock from '../assets/css/img/shock.png'

const GridComponent = () => {
  const Items = [
    { img: panel },
    { img: img4 },
    { img: img3 },
    { img: img },
    { img: img1 },
    { img: img2 },
   
  
    
  ];

  return (
    <div className="container">
      <div className="section-title text-center" data-aos="fade-up">
        <h1 className="p-4 green-heading">
          <img src={shock} className="shock" alt="Icon" />&nbsp; Our Major Clients
        </h1>
      </div>
      <div className="row d-flex justify-content-center ">
        {Items.map((item, index) => (
          <div key={index} className="col-12 col-md-3 d-flex justify-content-center align-items-center mb-4 ">
            <img src={item.img} alt={`${index + 1}`} className="img-fluid" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default GridComponent;









